import { Modal } from "pepsico-ds";
import { Box, Typography } from "@mui/material";
import Loading from "../../../../../utils/Loader";
const DeleteModal = ({
  title,
  setClose,
  open,
  handleDelete,
  text,
  loading,
}) => {
  return (
    <Modal
      onCloseModal={setClose}
      hideCloseButton={false}
      showModal={open}
      showAuxiliaryButton={false}
      showTertiaryButton={false}
      showLink={false}
      title={title}
      type="S"
      showPrimaryButton={true}
      showSecondaryButton={true}
      primaryButtonProps={{
        text: "Delete",
        variant: "primary",
        onClick: handleDelete,
      }}
      secondaryButtonProps={{
        text: "Go Back",
        variant: "secondary",
        onClick: setClose,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          marginTop: "12px",
        }}
      >
        {loading && <Loading />}
        <Typography
          sx={{
            color: "var(--Tokens-Text-Primary, #3A3A3A)",
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "var(--Typography-Font-Family-Body, Inter)",
            fontSize: "var(--Font-Size-Body, 16px)",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "var(--Line-Height-Body, 22px)", // 137.5%
          }}
        >
          {text}
        </Typography>
      </Box>
    </Modal>
  );
};

export default DeleteModal;
